export const KIOSK_REPORT_TABS = ['payout', 'daily', 'refunds', 'overview'] as const;
export type KioskReportTab = (typeof KIOSK_REPORT_TABS)[number];
export type KioskReportMethod = 'octopus' | 'card' | 'qr' | 'free';
export const REFUND_OUTCOMES = [
  'paid_by_tap', 'paid_after_deadline', 'refunded_by_provider', 'refunded_by_hand', 'refunded_twice', 'still_owed', 'refund_in_progress', 'refund_failed',
] as const;
export type RefundOutcome = (typeof REFUND_OUTCOMES)[number];
export const SETTLEMENT_OUTCOMES = ['ok', 'failed', 'interrupted'] as const;
export type SettlementOutcome = (typeof SETTLEMENT_OUTCOMES)[number];

export interface FilterOption {
  id: string;
  name: string;
}

export interface KioskReportFilterValues {
  startDate: string;
  endDate: string;
  siteId: string;
  kioskId: string;
  method: string;
}

export interface PayoutTotals {
  sessions: number;
  energy_kwh: number;
  kept: number;
  refunded: number;
  still_owed: number;
}

export interface PayoutRow extends PayoutTotals {
  site_id: string;
  site_name: string;
  month: string;
  method: KioskReportMethod;
}

export interface PayoutReport {
  rows: PayoutRow[];
  totals: PayoutTotals;
}

export interface DailyRow {
  day: string;
  method: Exclude<KioskReportMethod, 'free'>;
  kiosk_id: string | null;
  kiosk_name: string | null;
  taken_count: number;
  taken_total: number;
  refunded_count: number;
  refunded_total: number;
  hand_refunded_count: number;
  hand_refunded_total: number;
  settlement_outcome: SettlementOutcome | null;
  settlement_id: string | null;
}

export interface DailyReport {
  rows: DailyRow[];
}

export interface RefundsRow {
  outcome: RefundOutcome;
  count: number;
  amount: number;
  avg_hours_to_refund: number | null;
}

export interface RefundsReport {
  rows: RefundsRow[];
}

export interface OverviewTrendRow {
  month: string;
  kiosk_sessions: number;
  kiosk_energy_kwh: number;
  kiosk_kept: number;
  app_sessions: number;
  app_energy_kwh: number;
  app_revenue: number;
  kiosk_session_share: number | null;
  kiosk_revenue_share: number | null;
}

export interface OverviewRow extends OverviewTrendRow {
  site_id: string;
  site_name: string;
}

export interface OverviewReport {
  rows: OverviewRow[];
  trend: OverviewTrendRow[];
}

export interface KioskReportBodies {
  payout: PayoutReport;
  daily: DailyReport;
  refunds: RefundsReport;
  overview: OverviewReport;
}

export type LoadedKioskReport = { [K in KioskReportTab]: { tab: K; body: KioskReportBodies[K] } }[KioskReportTab];
